
import { BaseRenderTexture, Container, DisplayObject, Matrix, RenderTexture, SCALE_MODES, Sprite, Texture, WebGLRenderer } from "pixi.js";

interface BufferRendererDesc {
    width?: number;
    height?: number;
    scaleMode?: number;
    resolution?: number;
}

export class BufferRenderer {
    readonly sprite = new Sprite();
    readonly container = new Container();
    protected renderTexture: RenderTexture;
    private width = 1;
    private height = 1;
    private scaleMode = SCALE_MODES.LINEAR;
    private resolution = 1;
    constructor(protected renderer: WebGLRenderer, desc?: BufferRendererDesc) {
        this.width = desc?.width ?? 1;
        this.height = desc?.height ?? 1;
        this.scaleMode = desc?.scaleMode ?? SCALE_MODES.LINEAR;
        this.resolution = desc?.resolution ?? 1;
        this.updateBuffers();
    }

    protected updateBuffers() {
        this.renderTexture = new RenderTexture(
            new BaseRenderTexture(
                this.width,
                this.height,
                this.scaleMode,
                this.resolution
            )
        );
        this.sprite.texture = Texture.from(this.renderTexture.baseTexture);
    }

    draw(obj?: DisplayObject, matrix?: Matrix) {
        if (obj) {
            this.renderer.render(obj, this.renderTexture, false, matrix);
        } else {
            // todo: handle skip pixi update transform
            this.renderer.render(this.container, this.renderTexture, true);
        }
    }

    setSize(w: number, h: number) {
        this.width = w;
        this.height = h;
        this.sprite.width = w;
        this.sprite.height = h;
        this.updateBuffers();
    }
}